export const IGNORED_SENTRY_ERRORS = [
    {
        pattern: /^Error Message Shown: Search is having trouble understanding/,
        owner: '@dev/Review-Search-Data-FE',
        reason: 'Sage cannot match the first token of the query. Expected user ' +
            'input, not a fault. DoSearch is undebounced and the banner re-' +
            'reports on every message change, so one query emits one event per ' +
            'keystroke — and because the typed text is interpolated into the ' +
            'title, each keystroke also opens a NEW Sentry issue.',
        ticket: 'SCAL-338682',
    },
    {
        pattern: /^Error Message Shown: Search did not find/,
        owner: '@dev/Review-Search-Data-FE',
        reason: 'Same mechanism, different branch of the same Sage error handler ' +
            '(unmatched token at offset > 0). Largest issue in the project at ' +
            '8.6% of all events.',
        ticket: 'SCAL-337650',
    },
    {
        pattern: /^(?:ApolloError: )?com\.thoughtspot\.callosum\.common\.CallosumException:\s+Error Code: ACCESS_TOKEN_GENERATION_ERROR\b/,
        owner: '@dev/Review-Embrace',
        reason: 'Expected failures in this case of token expiry.',
        ticket: 'SCAL-340629',
    },
    {
        pattern: /^(?:ApolloError: )?No SessionStoreObject found for transaction id/,
        owner: '@dev/Review-Search-Data-FE',
        reason: 'Bach evicts a session from its store (Redis in prod) after ' +
            'sessionStoreTimeoutInHours of inactivity (default 8h). A request ' +
            'against an evicted session throws this (code 10097), which is ' +
            'expected for long-idle tabs, not a defect. Reproduced live: both ' +
            'a genuine idle-expiry eviction and a request carrying a session ' +
            'id Bach never created produce this exact, identical error — the ' +
            'message cannot distinguish the two, but neither is a coding ' +
            'mistake in this surface. Volume stays measurable via the ' +
            'SESSION_STORE_OBJECT_NOT_FOUND Mixpanel event already fired in ' +
            'trackBachError (blink-v2/src/services/bach/bach.ts).',
        ticket: 'SCAL-342418',
    },
];
export const getIgnoredErrorPatterns = () => IGNORED_SENTRY_ERRORS.map(entry => entry.pattern);
//# sourceMappingURL=sentry-ignored-errors.js.map